import React from "react";
import { HeaderBar, Footer } from "components/layouts";
import "./styles.scss";

interface LayoutProps {
  children: React.ReactElement[] | React.ReactNode;
}

const MainLayout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="main-layout-container">
      <HeaderBar />
      <div className="content-wrapper">{children}</div>
      <Footer />
    </div>
  );
};

export default MainLayout;
